/**
 Author - Saahil Madaan
 Git - https://bitbucket.org/techSavvySaahil/
 **/


import React from "react";
import PropTypes from "prop-types";

const Modal = ({
  heading,
  description,
  showButtons,
  confirmButtonText
}) => (
  <div aria-hidden="true" aria-labelledby="confirmationModalLabel" className="modal fade" id="confirmationModal" role="dialog" tabIndex="-1">
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="confirmationModalLabel">{heading}</h5>
          <button aria-label="Close" className="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>{description}</p>
        </div>
        {!!showButtons &&
            // eslint-disable-next-line react/jsx-indent
            <div className="modal-footer">
              <button className="btn btn-secondary" data-dismiss="modal" type="button">Close</button>
              <button className="btn btn-primary" type="button">{confirmButtonText}</button>
            </div>
        }
      </div>
    </div>
  </div>

);

const propTypes = {
  confirmButtonText: PropTypes.string,
  description: PropTypes.string,
  heading: PropTypes.string,
  showButtons: PropTypes.string
};

Modal.propTypes = propTypes;

export default Modal;
